import React, { useContext, useState, useEffect, useRef } from 'react';
import { UserContext } from '../Contexts/UserContext';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import { aoiService } from "../Services/aoiService";
import { eventService } from "../Services/eventService";
import Moment from "react-moment";
import EditEvent from "../Components/UserProfile/Events/EditEvent";
import CreateEvent from "../Components/UserProfile/Events/CreateEvent";
import EventDelete from "../Components/UserProfile/EventDelete";
import AoiEvents from "../Components/Events/AoiEvents";
import AOIEditLineModal from '../Components/AOI/AOIEditLineModal';
import EditIcon from '../Assets/img/icon-edit-grey.svg';
import DeleteIcon from '../Assets/img/icon-delete.svg';
import PipelineIcon from '../Assets/img/pipeline.svg';
import styles from './ManageAOIs.module.css';
import DeleteConfirmModal from '../Components/DeleteConfirmModal';
import toast from 'react-hot-toast';

const ManageAOIs = (props) => {
    let { aoiId } = useParams();
    const { selectedOrg, allAOIs, reloadAOIs } = useContext(UserContext);
    const [aoi, setAoi] = useState(null);
    const [showEditLine, setShowEditLine] = useState(false);
    const [editLine, setEditLine] = useState(null);
    const [selectedProperties, setSelectedProperties] = useState({});
    const [showDeleteLine, setShowDeleteLine] = useState(false);
    const fileInputRef = useRef(null);
    const [hasMilestones, setHasMilestones] = useState(false);

    useEffect(() => {
        if(aoiId != null) {
            const aoi = allAOIs.find(a => a.aoiId == aoiId);
            if(aoi != null) {
                setAoi(aoi);
                const milestone = aoi?.aoiGeometry?.find(ag => ag.geometryType == 'milestones');
                setHasMilestones(milestone != null);
            }
        }
    }, [allAOIs, aoiId]);

    const startEditLine = (line) => {
        setShowEditLine(true);
        setEditLine(line);
        setSelectedProperties(line ? JSON.parse(line.properties) : {color: '#ff0000', style: 'solid', strokeWeight: '3'});
    };

    const startDeleteLine = (line) => {
        setShowDeleteLine(true);
        setEditLine(line);
    };

    const onDeleteAoiLine = (confirm) => {
        if(confirm) {
            aoiService.deleteAoiGeometry(editLine.aoiGeometryId).then((data) => {
                toast.success("AOI Line deleted successfully");
                setShowDeleteLine(false);
                reloadAOIs();
            }).catch((error) => {
                console.error("Error deleting AOI Line:", error);
                toast.error("Failed to delete AOI Line");
            });
        }
    };

    const cancelEdit = () => {
        setEditLine(null);
    };

    const onSave = () => {
        reloadAOIs();
        cancelEdit();
    };

    const getContrastColor = (hexcolor) => {
        if (!hexcolor || hexcolor.length <= 6)
            return '#000000';
        hexcolor = hexcolor.replace("#", "");
        let r = parseInt(hexcolor.substr(0,2),16);
        let g = parseInt(hexcolor.substr(2,2),16);
        let b = parseInt(hexcolor.substr(4,2),16);
        let yiq = ((r*299)+(g*587)+(b*114))/1000;
        return (yiq >= 128) ? '#000000' : '#ffffff';
    };

    const handleButtonClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            aoiService.addMilestones(aoi.aoiId, file).then((data) => {
                toast.success("Milestones added successfully");
                reloadAOIs();
            }).catch((error) => {
                console.error("Error adding Milestones:", error);
                toast.error("Failed to add Milestones");
            });
        }
    };

    if(aoiId == null) {
        return  <div className={styles.pageBody}>
                    <h3>AOIs</h3>
                    <div className={styles.aoiList}>
                        {
                            allAOIs.map((aoi) => {
                                return <Link to={`/manageaois/${aoi.aoiId}`} key={aoi.aoiId}>{aoi.name}</Link>;
                            })
                        }
                    </div>
                </div>;
    }

    if(!selectedOrg.showAoiLines) {
        return <div className={styles.pageBody}>...</div>;
    }

    return (
        <div className={styles.pageBody}>
            <h3>AOI - {aoi?.name} &nbsp; &nbsp;
                 <button type="button" className="btn btn-primary" aria-label="Submit" onClick={() => startEditLine(null)}>
                    Add Lines
                </button>
                &nbsp; &nbsp;
                <button type="button" className="btn btn-primary" aria-label="Submit" onClick={handleButtonClick}>
                    {hasMilestones ? "Replace" : "Add"} Milestones
                </button>
                <input type="file" ref={fileInputRef} className="upload-input" onChange={handleFileChange} accept=".geojson" style={{display: "none"}}/>
            </h3>
            <div className="table-responsive">
                <table className="table table-style">
                    <thead>
                        <tr>
                            <th scope="col">Line Name</th>
                            <th scope="col">Weight</th>
                            <th scope="col">Color</th>
                            <th scope="col">Style</th>
                            <th scope="col" className={styles.action}>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            aoi && aoi.aoiGeometry && aoi.aoiGeometry.length > 0 &&
                            aoi.aoiGeometry.map((line) => {
                                if(line.geometryType != 'line') 
                                    return <></>;
                                const properties = JSON.parse(line.properties);
                                return <tr key={line.aoiGeometryId}>
                                    <td>{line.name}</td>
                                    <td>{properties.strokeWeight}</td>
                                    <td style={{backgroundColor: properties.color, color: getContrastColor(properties.color)}}>{properties.color}</td>
                                    <td>{properties.style}</td>
                                    <td className={styles.action}>
                                        {
                                            aoi.properties.pipelineId == line.aoiGeometryId && <img src={PipelineIcon} alt="Pipeline" title="This line is set as Pipeline" style={{width: '20px', height: '20px', marginRight: '10px'}} />
                                        }
                                        <a className="test" onClick={() => startEditLine(line)}><img src={EditIcon} alt="" title="Edit line" /></a> &nbsp; &nbsp;
                                        <a className="test" onClick={() => startDeleteLine(line)}><img src={DeleteIcon} alt="" title="Delete line" /></a>
                                    </td>
                                </tr>;
                            })
                        }
                    </tbody>
                </table>
            </div>
            {
                hasMilestones ? <div>Milestone(s) exist(s) in this AOI.</div> : <div>No Milestone exists in this AOI.</div>
            }
            {
                showEditLine &&
                <AOIEditLineModal setShow={setShowEditLine} line={editLine} properties={selectedProperties} aoi={aoi} onSave={onSave} />
            }
            {
                showDeleteLine &&
                <DeleteConfirmModal 
                    setShowDeleteConfirmModal={setShowDeleteLine} 
                    title="Confirm AOI Line Delete"
                    confirmByInput={true}
                    confirmValue={"Delete " + (editLine.name ?? "AOI Line")}
                    inputLabel={
                        `Do you want to Delete the Event <b>${editLine.name ?? ""}</b> ?<br><br>
                        Type <b>${"Delete " + (editLine.name ?? "AOI Line")}</b> to delete the Event: `
                    }
                    onConfirmDelete={onDeleteAoiLine}
                    onCancel={()=>onDeleteAoiLine(false)}
                />
            }
        </div>
    );
}

export default ManageAOIs;